module.exports = __webpack_public_path__ + "img/amazon.db88101e.png";